
/**
 * Generate a unique booking ID/confirmation number
 * 
 * @returns A unique alphanumeric booking ID
 */
export const generateUniqueId = (): string => {
  const randomPart = Math.random().toString(36).substring(2, 8).toUpperCase();
  const datePart = Date.now().toString().slice(-6);
  return `BK${randomPart}${datePart}`;
};

/**
 * Calculate booking price with any applicable discounts or additions
 * 
 * @param basePrice The base price of the service
 * @param options Additional booking options that may affect pricing
 * @returns The final calculated price
 */
export const calculateBookingPrice = (
  basePrice: number, 
  options?: {
    isRecurring?: boolean;
    recurringFrequency?: "weekly" | "biweekly" | "monthly";
    addons?: Array<{ name: string; price: number }>;
  }
): number => {
  let finalPrice = basePrice;
  
  // Add pricing logic here
  // For example, apply discounts for recurring bookings or add addon prices
  
  if (options?.isRecurring) {
    // Example: Apply a small discount for recurring bookings
    finalPrice *= 0.95;
  }
  
  if (options?.addons && options.addons.length > 0) {
    // Add prices of all addons
    const addonTotal = options.addons.reduce((sum, addon) => sum + addon.price, 0);
    finalPrice += addonTotal;
  }
  
  return finalPrice;
};
